export default __webpack_public_path__ + "static/media/offing-saba-keramati.e29476c7.webp";